import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Button, Table, Space, message } from "antd";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import LitigationModel from "../../BackgroundInfo/Litigation/LitigationModel";
import {
  createLitigations,
  deleteLitigations,
  getEntityAdminLitigations,
  updateLitigations,
} from "../../../../../services/adminForm.services";
import { useQuery } from "../../../../../helpers/utility";
import moment from "moment";

const dateFormat = "YYYY-MM-DD";

const EntityLitigation = ({ recordBucket, title, disable }) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [data, setData] = useState([]);

  const query = useQuery();
  const applicationId = query.get("id");

  const columns = [
    { title: "Case Name", dataIndex: "case_name", key: "case_name", ellipsis: true, width: 120 },
    { title: "Court", dataIndex: "court", key: "court", ellipsis: true, width: 120 },
    { title: "Index No", dataIndex: "index_no", key: "index_no", ellipsis: true, width: 100 },
    { title: "Date Filed", dataIndex: "date_filed", key: "date_filed", ellipsis: true, width: 120 },
    { title: "Type Of Action", dataIndex: "type_of_action", key: "type_of_action", ellipsis: true, width: 140 },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  function openModal(row) {
    setVisible(true);
    setEditTable(row);
  }

  function fetchRows() {
    getEntityAdminLitigations({ applicationId, recordBucket })
      .then((res) => setData(res.data))
      .catch((error) => {
        console.error("get entity litigations error", error);
        if (error && error.response) {
          message.error(error.response.data.message || error.response.message || "Something Went Wrong");
        } else {
          message.error("get entity litigations error");
        }
      });
  }

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationId, recordBucket]);

  function save(values) {
    const payload = {
      ...values,
      date_filed: moment(values.date_filed).format(dateFormat),
      application: applicationId,
      ownership: null,
      record_bucket: recordBucket,
    };

    createLitigations(payload)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Saved");
        fetchRows();
      })
      .catch((error) => {
        console.error("save entity litigations error", error);
        if (error && error.response) {
          message.error(error.response.data.message || error.response.message || "Failed to save");
        } else {
          message.error("save entity litigations error");
        }
      });
  }

  function update(values) {
    const payload = {
      ...values,
      date_filed: moment(values.date_filed).format(dateFormat),
      application: applicationId,
      record_bucket: recordBucket,
    };

    updateLitigations(editTable.id, payload)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Updated");
        fetchRows();
      })
      .catch((error) => {
        console.error("update entity litigations error", error);
        if (error && error.response) {
          message.error(error.response.data.message || error.response.message || "Failed to update");
        } else {
          message.error("update entity litigations error");
        }
      });
  }

  function removeColumn(id) {
    deleteLitigations(id)
      .then((res) => {
        message.success(res.data.message || "Removed");
        fetchRows();
      })
      .catch((error) => {
        console.error("delete entity litigations error", error);
        if (error && error.response) {
          message.error(error.response.data.message || error.response.message || "Failed to remove");
        } else {
          message.error("delete entity litigations error");
        }
      });
  }

  return (
    <Fragment>
      <Row style={disable ? { pointerEvents: "none" } : {}}>
        <Col>
          <Button
            onClick={() => openModal({ status: "create" })}
            type="secondary"
            style={{ marginBottom: 16 }}
          >
            Add Details
          </Button>
        </Col>
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            pagination={false}
            dataSource={data}
            scroll={{ x: 900 }}
          />
        </Col>
      </Row>
      {visible && (
        <LitigationModel
          create={save}
          update={update}
          title={title}
          editTable={editTable}
          setVisible={setVisible}
        />
      )}
    </Fragment>
  );
};

export default EntityLitigation;

